import { Component, Input } from '@angular/core';
import { BoxProps, boxStyles } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-box',
  template: '<div [ngClass]="boxStyles"><ng-content></ng-content></div>',
})
export class BoxComponent {
  /**
   * Css del componente
   */
  @Input() css: BoxProps['css'];

  public get boxStyles(): string[] {
    return [
      boxStyles({
        css: this.css,
      }).className,
    ];
  }
}
